import React, { useRef, useState } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';
import uuid from 'react-uuid';

interface FileUploadProps {
  onFileSelect: (files: FileList | null) => void;
  multiple?: boolean;
  accept?: string;
  className?: string;
  buttonText?: string;
  error?: string;
}

export const FileUpload: React.FC<FileUploadProps> = ({
  onFileSelect,
  multiple = false,
  accept = '',
  className,
  buttonText = 'Choose File',
  error,
}) => {
  const [selectedFiles, setSelectedFiles] = useState<FileList | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const inputId = uuid();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    setSelectedFiles(files);
    onFileSelect(files);
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <div className={cn(className, styles.FileUploadGroup)}>
      <div className={cn(styles.FileUpload)}>
        <input
          type="file"
          id={inputId}
          ref={inputRef}
          onChange={handleFileChange}
          multiple={multiple}
          accept={accept}
          style={{ display: 'none' }} // Hide the default input
        />
        <button onClick={handleButtonClick}>{buttonText}</button>
        <label htmlFor={inputId}>
          {selectedFiles && selectedFiles.length > 0 ? (
            multiple && selectedFiles.length > 1 ? (
              <>
                {`${selectedFiles.length} files selected: `}
                {Array.from(selectedFiles).map((file) => (
                  <span key={file.name}>{file.name}</span>
                ))}
              </>
            ) : (
              <span>{selectedFiles[0].name}</span>
            )
          ) : (
            'No file chosen'
          )}
        </label>
      </div>
      {error && <span className={cn(styles.TextFieldErrorMsg)}>{error}</span>}
    </div>
  );
};
